import React, { Component } from 'react';
import '../../styles/commoncomponents/searchBar.scss';
class Search extends Component {
    timeoutId;

    componentWillUnmount() {
        if (this.timeoutId !== undefined)
            clearTimeout(this.timeoutId);
    }

    handleInput(e) {
        let searchText = e.target.value;
        if (this.timeoutId !== undefined)
            clearTimeout(this.timeoutId);

        // Set a new timeout
        this.timeoutId = setTimeout(() => {
            this.props.searchCallback(searchText);
        }, this.props.debounceMs || 1000);
    }

    render() {
        return (
            <div className="Search">
                Search: <input onChange={this.handleInput.bind(this)} type="text"></input>
            </div>
        );
    }
}

export default Search;
